import { Navigate } from '@sorare/routing';

import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import { ANY_SPORT_MARKET_COMMON_PACKS } from '@sorare/core/src/constants/routes';
import { generateSportPath } from '@sorare/core/src/lib/routing/generateSportPath';

const MobileCommonPacksPage = () => {
  return (
    <Navigate
      to={generateSportPath(ANY_SPORT_MARKET_COMMON_PACKS, {
        sport: Sport.FOOTBALL,
      })}
    />
  );
};

export default MobileCommonPacksPage;
